import { FC } from 'react';
import { Box, Card } from '@qga/roo-ui/components';
import { DetailsBooking } from 'types';
import { ContentHeading } from 'components/Typography';
import { HorizontalRule } from 'components/Layout';
import CancellationInfo from './CancellationInfo';
import PolicyTimeline from './PolicyTimeline';

const CancellationPolicy: FC<{ booking: DetailsBooking }> = ({ booking }) => {
  if (booking.flags.isCancelled || booking.reservation.isAfterCheckOut) {
    return null;
  }

  // TEMP fix for https://sentry.io/organizations/qantashotels/issues/1728467426/
  if (!booking.reservation.cancellationPolicy) {
    return null;
  }

  if (!booking.reservation.cancellationPolicy.activeCancellationWindow) {
    return null;
  }

  return (
    <Box mb={8} data-testid="booking-cancellation-policy">
      <ContentHeading>Cancellation policy</ContentHeading>
      <Card display="block" p={0}>
        <CancellationInfo booking={booking} />
        <HorizontalRule m={0} />
        <PolicyTimeline booking={booking} />
      </Card>
    </Box>
  );
};

export default CancellationPolicy;
